import React from 'react';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';

import { middleware as analyticsMiddleware } from '@eb/site-analytics';
import { configureStore } from '@eb/redux-configure-store';

import { getInitialState } from './redux';
import { rootReducer } from './redux/root';

import { HomeBaseContainer } from './containers/HomeBaseContainer';

export default class HomePage extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer: rootReducer,
            initialState: getInitialState(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    render() {
        return (
            <Provider store={this._store}>
                <HomeBaseContainer {...this.props} />
            </Provider>
        );
    }
}
